import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useTotalDiscountSummaryV2 = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.totalDiscountSummaryV2, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getTotalDiscountSummaryV2(), {
        params,
      });

      const composeResponse = {
        clinicTotalDiscounts:
          res.data.data.report.clinic_total_discounts_summary,
        providerTotalDiscounts:
          res.data.data.report.provider_total_discounts_summary,
      };
      return composeResponse;
    },
    options,
  );
};
